import React from 'react';
import { Grid } from '@material-ui/core';
import Img from '../wrappedImage';
import MDXParser from '../mdxParser';
import Typography from '@material-ui/core/Typography';
import { useStaticQuery, graphql } from 'gatsby';
import Container from '@material-ui/core/Container';

// Content
import SavingLives from '../../sections/SavingLives/SavingLives';
import SavingLivesSubtitle from '../../sections/SavingLives/SavingLivesSubtitle';

import SavingLivesTwo from '../../sections/SavingLives/SavingLivesTwo';
import SavingLivesThree from '../../sections/SavingLives/SavingLivesThree';
import Yemen from '../../sections/SavingLives/Yemen';
import Syria from '../../sections/SavingLives/Syria';
import SouthSudan from '../../sections/SavingLives/SouthSudan';
import CentralSahel from '../../sections/SavingLives/CentralSahel';
import Congo from '../../sections/SavingLives/Congo';
import NorthEasternNigeria from '../../sections/SavingLives/NorthEasternNigeria';
import Mozambique from '../../sections/SavingLives/Mozambique';

import ForgottenCrises1 from '../../sections/SavingLives/ForgottenCrises';
import ForgottenCrises2 from '../../sections/SavingLives/ForgottenCrises2';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    forgottenCrises: {
      backgroundColor: '#0076bc',
    },
    forgottenText: {
      padding: '30px 0',
      color: 'white',
    },
    root: {
      padding: '20px 0',
    },
    text: {
      padding: '0px 20px',
      display: 'flex',
      backgroundColor: 'transparent',
      flexDirection: 'column',
      boxShadow: 'none',
      borderRadius: '0px',
    },
    imageLarge: {
      width: '100%',
      height: 'auto',
    },
    image: {
      width: '100%',
      height: 'auto',
      border: '4px solid white',
    },
    flex: {
      display: 'flex',
    },
    subTitle: {
      padding: '12px 0 0 12px!important',
    },
  }),
);

type Props = { children: React.ReactNode; image: string, copyText: string };

const Detail = (props: Props) => {
  const classes = useStyles();

  return (
    <Grid container spacing={3} style={{ display: 'flex' }}>
      <Grid item xs={12} md={6} style={{ display: 'flex' }}>
        <Img fluid={props.image.childImageSharp.fluid} className={classes.image} alt="Image" copyText={props.copyText} />
      </Grid>

      <Grid item xs={12} md={6}>
        <MDXParser color="#0076bb">{props.children}</MDXParser>
      </Grid>
    </Grid>
  );
};

const SavingLivesSection = () => {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query {
      centralsahel: file(relativePath: { eq: "BKF_20191113_WFP-Marwa_Awad_1775.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      congo: file(relativePath: { eq: "congo.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      mozambique: file(relativePath: { eq: "MOZ_20190410_WFP-Alexis_Masciarelli_7583.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      nigeria: file(relativePath: { eq: "nigeria.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      sudan: file(relativePath: { eq: "sudan.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      syria: file(relativePath: { eq: "syria.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      forgottenCrises: file(relativePath: { eq: "forgottenCrises.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      yemen: file(relativePath: { eq: "yemen.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <>
      <Container maxWidth={false} disableGutters={true} className={classes.root}>
        <Container className={classes.container}>
          <div className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <MDXParser>
                  <SavingLives />
                </MDXParser>
              </Grid>

              <Grid item xs={12} md={12} className={classes.subTitle}>
                <MDXParser>
                  <SavingLivesSubtitle />
                </MDXParser>
              </Grid>

              <Grid item xs={12} md={6}>
                <MDXParser>
                  <SavingLivesTwo />
                </MDXParser>
              </Grid>

              <Grid item xs={12} md={6}>
                <MDXParser>
                  <SavingLivesThree />
                </MDXParser>
              </Grid>

              <Grid item xs={12} md={12}>
                <Detail image={data.yemen} copyText='WFP/Mohammed Awadh'>
                  <Yemen />
                </Detail>
                <Detail image={data.syria} copyText='WFP/Khudr Alissa'>
                  <Syria />
                </Detail>
                <Detail image={data.sudan} copyText='WFP/Gabriela Vivacqua'>
                  <SouthSudan />
                </Detail>
                <Detail image={data.centralsahel} copyText='WFP/Marwa Awad'>
                  <CentralSahel />
                </Detail>
                <Detail image={data.congo} copyText='Jacques David'>
                  <Congo />
                </Detail>
                <Detail image={data.nigeria} copyText='Inger-Marie Vennize'>
                  <NorthEasternNigeria />
                </Detail>
                <Detail image={data.mozambique} copyText='WFP/Alexis Masciarelli'>
                  <Mozambique />
                </Detail>
              </Grid>
            </Grid>
          </div>
        </Container>
      </Container>
      <Container maxWidth={false} disableGutters={true} className={classes.forgottenCrises}>
        <Container className={classes.flex}>
          <Grid container spacing={3} className={classes.flex}>
            <Grid item xs={12} md={6}>
              <div className={classes.forgottenText}>
                <MDXParser linkColor="white" color="white">
                  <ForgottenCrises1 />
                </MDXParser>

                <MDXParser linkColor="white">
                  <ForgottenCrises2 />
                </MDXParser>
              </div>
            </Grid>

            <Grid item xs={12} md={6} className={classes.flex} style={{ padding: '12px 0px' }}>
              <Img
                fluid={data.forgottenCrises.childImageSharp.fluid}
                className={classes.imageLarge}
                alt="Image"
                copyText='WFP/Nafisa Reshtin'
              />
            </Grid>
          </Grid>
        </Container>
      </Container>
    </>
  );
};

export default SavingLivesSection;
